<template>
  <div>
    <table class="table table-bordered">
      <thead class="bg-dark text-white">
        <tr>
          <th class="text-center">
            <div>{{ $t("common.language") }} <LanguageFilter indent="template" :request="request" @changed="languageFilterChanged" /></div>
          </th>
          <th class="align-middle">{{ $t("common.version") }}</th>
          <th class="align-middle">{{ $t("common.created-by") }}</th>
          <th class="align-middle">{{ $t("common.at") }}</th>
          <th class="align-middle">{{ $t("legal-document.name") }}</th>
          <th class="align-middle">{{ $t("legal-document-template.text") }}</th>
          <th class="align-middle">{{ $t("file-manager.file") }}</th>
          <th class="align-middle">
            <a href="javascript:;" @click="toggleFilter">
              <span v-if="filterEnabled" class="text-warning">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-hide") }}
              </span>
              <span v-else class="text-white">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-show") }}
              </span>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="filterEnabled">
          <th></th>
          <th><input class="form-control" v-model.number="versionFilter" /></th>
          <th></th>
          <th></th>
          <th><input class="form-control" v-model="nameFilter" /></th>
          <th></th>
        </tr>
        <template v-if="pagination">
          <tr v-for="item in pagination.docs" :key="item._id">
            <td>
              <language-badge v-if="item.template" :langCode="item.template.language" />
            </td>
            <td>{{ item.version }}</td>
            <td>
              <span v-if="item.createdBy">{{ item.createdBy.name }}</span>
            </td>
            <td>{{ item.createdAt | date(true) }}</td>
            <td>{{ item.name | translate }}</td>
            <td>
              <span v-if="item.template">
                {{ item.template.name | translate }}
              </span>
            </td>
            <td>
              <span v-if="item.file" @click="downloadFile(item.file)" v-b-tooltip.hover :title="$t('common.show')" class="hand">
                <i class="bx bx-search align-middle mr-1"></i>
                {{ item.file.name | translate }}
              </span>
              <span v-else>
                <i>({{ $t("file-manager.not-found") }})</i>
              </span>
            </td>

            <td>
              <i class="bx bx-trash text-danger hand mr-3 font-size-14" v-b-tooltip.hover :title="$t('legal-document.delete')" @click="deleteById(item._id)"></i>
            </td></tr
        ></template>
      </tbody>
    </table>
    <content-loading v-if="isLoading" />
    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)" width="200px">
      <h4 class="text-center">{{ $t("common.no-data") }}</h4>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import LanguageBadge from "@c/language-badge";
import LanguageFilter from "@c/language-filter";
import LibraryItems from "@cc/library-items";

const state = "organizationLegalDocument";
export default {
  props: ["product"],
  components: { LibraryItems, LanguageBadge, LanguageFilter },
  data() {
    return {
      nameFilter: undefined,
      versionFilter: undefined,
      filterEnabled: false,
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: { approved: { value: true, isObject: true } },
      },
    };
  },
  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    isLoading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    hasApproveOrRejectPermission() {
      if (this.currentAccountHasPermissions(["ORGANIZATION_LEGAL_ADMIN"])) {
        return true;
      }

      return false;
    },
  },
  watch: {
    request: {
      deep: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    nameFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },
    versionFilter(n, o) {
      if (n && n != "" && n != " ") {
        this.request.query = {
          ...this.request.query,
          version: { value: Number(n), isObject: true },
        };
      } else {
        this.request.query["version"] = null;
        delete this.request.query["version"];
      }
    },
  },
  mounted() {
    if (this.product) {
      this.request = { ...this.request, query: { ...this.request.query, products: { value: this.product, isObject: true } } };
    }
  },
  methods: {
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
    async paginate() {
      await this.$store.dispatch(`${state}/paginate`, this.request);
    },
    languageFilterChanged(e) {
      this.request = e;
    },

    downloadFile(file) {
      // this.$store.commit("organizationFileCategory/selectedParentCategory", file.category);
      if (file.isPeriodical && file.approval?.path) {
        this.$store.commit("fileManager/selectedTab", 1);
        this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-approval-survey/${file._id}/survey`);
        return;
      }

      const url = this.currentProduct ? `/${this.currentProduct}/file-manager` : "/organization/file-manager";
      this.$router.push({ path: url, query: { id: file._id, ...(file.historyId ? { historyId: file.historyId } : {}) } });
      //  this.$store.commit("fileManager/addDownloadedFile", {file});
    },
    async deleteById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/delete`, id);
        this.paginate();
        this.$toast.success(this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
